import { Skeleton } from "react-vant";

export function ProductListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="product-card-h skeleton">
          <Skeleton avatar avatarSize={90} avatarShape="square" loading row={3} />
        </div>
      ))}
    </div>
  );
}

/**
 * Compact horizontal-scroll skeleton — matches ProductCard variant="compact"
 * dimensions to keep the lane height stable during the first paint.
 */
export function CompactCardLaneSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="scroll-lane">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="product-card-compact"
          style={{ pointerEvents: "none" }}
        >
          <Skeleton avatar avatarSize="100%" avatarShape="square" loading row={2} />
        </div>
      ))}
    </div>
  );
}

/**
 * Brand hero skeleton — placeholder for BrandPage's editorial title hero
 * (Playfair brand name on bgSubtle) while BrandDetail resolves.
 */
export function BrandHeroSkeleton() {
  return (
    <div
      style={{
        padding: "48px 16px 32px",
        background: "var(--color-bg-subtle)",
        textAlign: "center",
        borderBottom: "1px solid var(--color-border)",
      }}
    >
      <div
        style={{
          width: 80,
          height: 12,
          margin: "0 auto 16px",
          background: "rgba(11,11,11,0.06)",
        }}
      />
      <div
        style={{
          width: 220,
          height: 32,
          margin: "0 auto",
          background: "rgba(11,11,11,0.08)",
        }}
      />
      <div
        style={{
          width: 32,
          height: 1,
          background: "var(--color-gold)",
          margin: "24px auto 0",
        }}
      />
    </div>
  );
}

/**
 * Detail page hero + content skeleton.
 */
export function DetailSkeleton() {
  return (
    <div>
      <div
        style={{
          width: "100%",
          height: 375,
          background: "var(--color-bg-subtle)",
        }}
      />
      <div className="card">
        <Skeleton row={3} loading title />
      </div>
      <div className="card">
        <Skeleton row={4} loading />
      </div>
      <div className="card">
        <Skeleton row={3} loading />
      </div>
    </div>
  );
}
